import React, {useState, useRef, useEffect}  from 'react';

// For Applying CSS transitions to elements

/*
MAIN :: PROPS {
  onClick:FUNCTION      - Passed onclick function that binds to "container" of CSS transistion
  active:STRING,        - Class that is bound to container when transistion is "active"
  inactive:STRING,      - Class that is bound to container when transistion is "inactive"
  controller:FUNCTION,  - Passed function for accessing state of transistion and reference to container
  duration:NUMBER       - Number that determines duration of transistion (defaults to 1000)
}
*/
export default function BCMSTransistion(props) {
  const [get, set] = useState(false);   // Stores state of when to show "active" styles that communicate what's clickable
  const elem = useRef(null);
  if (props.controller) {
    props.controller(get, set, elem);
  }
  // Changes style of transition container depending on state:
  useEffect(() => {
    let timerID;
    if (get) {
      timerID = setTimeout(() => set(false), props.duration ?? 1000);
    }
    // Clears timeout on unmount:
    return () => {
      timerID && clearTimeout(timerID);
    }
  })
  return (
    <div onClick={props.onClick} className={get ? props.active : props.inactive} ref={elem}>
      {props.children}
    </div>
  )
}
